// extracted by mini-css-extract-plugin
export default {"container":"common_container__fKQ-f","text":"common_text__5vl+B","actions":"common_actions__AY6My","dropdown":"common_dropdown__RvKkj"};